module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"text-edit-in-modus":"In Bearbeitung"},"fr":{"text-edit-in-modus":"En cours de traitement"},"it":{"text-edit-in-modus":"In fase di elaborazione"}}')
  delete Component.options._Ctor
}
